import { motion } from "framer-motion"

const loadingAnim = {
    hidden: {
        x: '-200%'
    },
    visible: {
        x: '200%',
        transition: {
            repeat: Infinity,
            repeatType: 'loop',
            duration: 1,
            type: "linear"
        }
    }
}

const FieldLoader = ({ height = "h-1", injectClass = "" }) => {
    return (
        <div className={`${height} overflow-hidden rounded-full bg-primeColor/10 ${injectClass}`}>
            <motion.div variants={loadingAnim} initial="hidden" animate="visible" className={`w-1/2 ${height} rounded-full bg-primeColor`}></motion.div>
        </div>
    )
}

export default FieldLoader
